import InfiniteScroll from 'react-infinite-scroll-component'
import { Grid, styled } from '@mui/material'

import { useAppDispatch, useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import Loader from 'features/common/ui/utils/Loader'
import useInfiniteScrollPagination from 'features/common/ui/Pagination/useInfiniteScrollPagination'
import { setMapFilterPagination, setMyMapsStatus } from 'features/maps/state/mapsSlice'
import { MAPS_REMOTE_PAGE_SIZE } from 'features/maps/api/maps'
import { useCallback } from 'react'
import useFixMissingScroll from 'features/common/hooks/useFixMissingScroll'

import MapsList from './MapsList'

const InfiniteScrollMapsList = styled(InfiniteScroll)(({ theme }) => ({
  padding: theme.spacing(3),
  paddingRight: 0
}))

const InfiniteLoader = styled(Loader)(({ theme }) => ({
  marginTop: theme.spacing(5)
}))

function InfiniteScrollableMapsList() {
  const dispatch = useAppDispatch()
  const mapsMetadata = useAppSelector((state) => state.maps.myMapsMetadata)
  const mapsStatus = useAppSelector((state) => state.maps.myMapsStatus)
  const maps = useAppSelector((state) => state.maps.myMaps)

  const { localPage, hasToRequestNextPage, hasMoreElements, nextPage } = useInfiniteScrollPagination({
    remoteList: maps,
    metadata: mapsMetadata,
    requestStatus: mapsStatus,
    remotePageSize: MAPS_REMOTE_PAGE_SIZE
  })

  const filterLoading = mapsStatus === RequestStatus.Pending

  const requestNextPageIfNeeded = useCallback(() => {
    if (hasToRequestNextPage) {
      dispatch(setMapFilterPagination({ page: (mapsMetadata?.current || 0) + 1 }))
      dispatch(setMyMapsStatus(RequestStatus.Idle))
    }
  }, [dispatch, hasToRequestNextPage, mapsMetadata])

  // Workflows section has an integration with useQuery
  const getNextPage = useCallback(() => {
    if (!mapsMetadata) return
    requestNextPageIfNeeded()
    nextPage()
  }, [mapsMetadata, nextPage, requestNextPageIfNeeded])

  useFixMissingScroll({
    hasMoreItems: hasMoreElements,
    fetchMoreItems: getNextPage
  })

  return (
    <>
      {!localPage.length && filterLoading ? (
        <InfiniteLoader />
      ) : (
        <InfiniteScrollMapsList
          next={getNextPage}
          dataLength={localPage.length}
          hasMore={hasMoreElements}
          loader={<InfiniteLoader />}
          scrollableTarget={document.querySelector('main')}
        >
          <Grid container spacing={3}>
            <MapsList maps={localPage} />
          </Grid>
        </InfiniteScrollMapsList>
      )}
    </>
  )
}

export default InfiniteScrollableMapsList
